import {notification as antNotification} from "antd";

export const notification = antNotification;
export default notification;
